import { MainMenuEnum, MainMenuRouteEnum } from '../enums/navigation.enum';
import { UserPositionEnum } from '../enums/user-position.enum';
import { MainMenuModel } from '../models/navigation.model';

export const getMainMenu = (userProfile: any): MainMenuModel[] => [
  {
    id: MainMenuEnum.Clients,
    name: 'Customers',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.Clients,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'customers-icon',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.Clients,
        name: 'Customers List',
        hasSidebar: false,
        route: MainMenuRouteEnum.Clients,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
      id: MainMenuEnum.PendingUsers,
      name: 'Leads',
      hasSidebar: false,
      route: MainMenuRouteEnum.PendingUsers,
      show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
    },
    {
      id: MainMenuEnum.ZonelessHomes,
      name: 'Zoneless Homes',
      hasSidebar: false,
      route: MainMenuRouteEnum.ZonelessHomes,
      show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
      external: false,
    },
  ]
  },
  {
    id: MainMenuEnum.Scheduler,
    name: 'Dispatch',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.Scheduler,
    show: true,
    icon: 'calendar-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.Zones,
        name: 'Zones',
        hasSidebar: false,
        route: MainMenuRouteEnum.Zones,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.Scheduler,
        name: 'Dispatch Board',
        hasSidebar: false,
        route: MainMenuRouteEnum.Scheduler,
        show: true,
        external: false,
      },
      {
        id: MainMenuEnum.DailyTasks,
        name: 'Daily Tasks',
        hasSidebar: false,
        route: MainMenuRouteEnum.DailyTasks,
        show: true,
        external: false,
      },
    ]
  },
  {
    id: MainMenuEnum.GarbageCompanies,
    name: 'Company',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.GarbageCompanies,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'company-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.GarbageCompanies,
        name: 'Garbage Companies',
        hasSidebar: false,
        route: MainMenuRouteEnum.GarbageCompanies,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.Employees,
        name: 'Employees',
        hasSidebar: false,
        route: MainMenuRouteEnum.Employees,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.Trucks,
        name: 'Trucks',
        hasSidebar: false,
        route: MainMenuRouteEnum.Trucks,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      }
    ]
  },
  {
    id: MainMenuEnum.Service,
    name: 'Service',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.ServiceRequests,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'service-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.Service,
        name: 'Service Requests',
        hasSidebar: false,
        route: MainMenuRouteEnum.ServiceRequests,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.FinanceSettings,
        name: 'Services Setup',
        hasSidebar: false,
        route: MainMenuRouteEnum.FinanceSettings,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      }
    ]
  },
  {
    id: MainMenuEnum.Offers,
    name: 'Finance',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.Offers,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'finance-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.Offers,
        name: 'Packages',
        hasSidebar: false,
        route: MainMenuRouteEnum.Offers,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.Billing,
        name: 'Transactions',
        hasSidebar: false,
        route: MainMenuRouteEnum.Billing,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.Coupons,
        name: 'Coupons',
        hasSidebar: false,
        route: MainMenuRouteEnum.Coupons,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.UnpaidServices,
        name: 'Unpaid Jobs',
        hasSidebar: false,
        route: MainMenuRouteEnum.UnpaidServices,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      }
    ]
  },
  {
    id: MainMenuEnum.ASettings,
    name: 'Settings',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.ASettings,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'settings-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.ASettings,
        name: 'Settings',
        hasSidebar: false,
        route: MainMenuRouteEnum.ASettings,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      // {
      //   id: MainMenuEnum.Checkout,
      //   name: 'Checkout',
      //   hasSidebar: false,
      //   route: MainMenuRouteEnum.Checkout,
      //   show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
      // },
      {
        id: MainMenuEnum.CustomerPortal,
        name: 'Customer Portal',
        hasSidebar: false,
        route: MainMenuRouteEnum.CustomerPortal,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.CustomerPortal,
        name: 'Devices',
        hasSidebar: false,
        route: MainMenuRouteEnum.Devices,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
    ]
  },
  {
    id: MainMenuEnum.Analytics,
    name: 'Analytics',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.Analytics,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'analytics-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.Analytics,
        name: 'Analytics',
        hasSidebar: false,
        show: false,
        route: MainMenuRouteEnum.Analytics,
        external: false,
        // show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
      },
      {
        id: MainMenuEnum.DriverAnalytics,
        name: 'Driver Analytics',
        hasSidebar: false,
        route: MainMenuRouteEnum.DriverAnalytics,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
    ]
  },
  {
    id: MainMenuEnum.Notification,
    name: 'Notifications',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.Notification,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'notification-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.Notification,
        name: 'Messages',
        hasSidebar: false,
        route: MainMenuRouteEnum.Notification,
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: false,
      },
      {
        id: MainMenuEnum.NotificationList,
        name: 'Notification Templates',
        hasSidebar: false,
        route: MainMenuRouteEnum.NotificationList,
        // show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        show: true,
        external: false,
      }
    ]
  },
  {
    id: MainMenuEnum.Help,
    name: 'Help',
    isOpen: false,
    hasSubMenu: true,
    hasSidebar: false,
    route: MainMenuRouteEnum.Notification,
    show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
    icon: 'help-header-menu',
    external: false,
    subMenu: [
      {
        id: MainMenuEnum.Help,
        name: 'Video Tutorial Library',
        hasSidebar: false,
        route: 'https://www.loom.com/share/folder/416d244478da4a96a62a1e98b7ea0a39',
        show: userProfile.positions.findIndex(p => p.position === UserPositionEnum.OfficeManager) !== -1,
        external: true,
      },
    ]
  },
];
